var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "card card__subscription p-4 p-lg-6" }, [
        _vm.subscriptionCancelled
          ? _c("div", { staticClass: "alert alert-success mb-2" }, [
              _vm._v(
                "Subscription package successfully\n            cancelled\n        "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.subscriptionResumed
          ? _c("div", { staticClass: "alert alert-success mb-2" }, [
              _vm._v(
                "Subscription package successfully\n            resumed\n        "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("h2", { staticClass: "t-orange mb-3" }, [
          _vm._v("Update your subscription")
        ]),
        _vm._v(" "),
        _vm.isSubscribedPastDueInvoices
          ? _c("p", { staticClass: "p1 mb-3" }, [
              _vm._v(
                "\n            You have one or more unpaid invoices. Please pay your past due invoices before the the end of the current billing period - "
              ),
              _c("strong", [_vm._v(_vm._s(_vm.currentSubscriptionPeriodEnd))]),
              _vm._v(" - to continue using your "),
              _c("strong", [_vm._v(_vm._s(_vm.currentPlan.name))]),
              _vm._v(" plan.\n        ")
            ])
          : _vm.canCancelSubscription
          ? _c("p", { staticClass: "p1 mb-3" }, [
              _vm._v("You can upgrade/downgrade or cancel your "),
              _c("strong", [_vm._v(_vm._s(_vm.currentPlan.name))]),
              _vm._v(" monthly\n            subscription of "),
              _c("strong", [_vm._v("£" + _vm._s(_vm.currentPlan.price))]),
              _vm._v(
                " at any time. If you do decide to cancel your payment then you will no longer have access to\n            your contributions or CAT-UXO data after the end of the current billing period on "
              ),
              _c("strong", [_vm._v(_vm._s(_vm.currentSubscriptionPeriodEnd))]),
              _vm._v(".")
            ])
          : _vm.canResumeSubscription
          ? _c("p", { staticClass: "p1 mb-3" }, [
              _vm._v("Your "),
              _c("strong", [_vm._v(_vm._s(_vm.currentPlan.name))]),
              _vm._v(" monthly\n            subscription ends on "),
              _c("strong", [_vm._v(_vm._s(_vm.resumeSubscriptionDate))]),
              _vm._v(
                ". If you wish to continue using the service features after this date, please resume your subscription."
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-sm-flex align-items-center" },
          [
            _vm.hasPastDueInvoices
              ? _c("pay-past-due-invoices")
              : _vm.canUpdateSubscription
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-form mr-4 mb-3 mb-sm-0",
                    on: {
                      click: function($event) {
                        return _vm.showModal()
                      }
                    }
                  },
                  [_vm._v("Edit Subscription")]
                )
              : _vm._e(),
            _vm._v(" "),
            [
              _vm.canResumeSubscription
                ? _c("cat-uxo-billing-resume-subscription", {
                    on: {
                      success: function($event) {
                        _vm.subscriptionResumed = true
                      }
                    }
                  })
                : _vm.canCancelSubscription
                ? _c("cat-uxo-billing-cancel-subscription", {
                    on: {
                      success: function($event) {
                        _vm.subscriptionCancelled = true
                      }
                    }
                  })
                : _vm._e()
            ]
          ],
          2
        )
      ]),
      _vm._v(" "),
      _vm.modalVisible
        ? _c(
            "cat-uxo-modal",
            {
              on: {
                close: function($event) {
                  return _vm.hideModal()
                }
              }
            },
            [
              _c(
                "h2",
                {
                  staticClass: "text-center t-orange",
                  attrs: { slot: "header" },
                  slot: "header"
                },
                [_vm._v("Edit your subscription package")]
              ),
              _vm._v(" "),
              _c(
                "subscriptions",
                {
                  staticClass: "mb-5",
                  attrs: { slot: "body", plans: _vm.plans },
                  slot: "body"
                },
                _vm._l(_vm.plans, function(plan, index) {
                  return _c(
                    "a",
                    {
                      key: plan.id,
                      staticClass: "btn w-100",
                      class: { "btn-ghost": _vm.selectedPlanId !== plan.id },
                      attrs: { slot: index === 0 ? "buttonOne" : "buttonTwo" },
                      on: {
                        click: function($event) {
                          _vm.selectedPlan = plan.id
                        }
                      },
                      slot: index === 0 ? "buttonOne" : "buttonTwo"
                    },
                    [
                      _vm._v(
                        _vm._s(
                          plan.id !== _vm.user.current_billing_plan
                            ? "Choose this plan"
                            : "Your current plan"
                        )
                      )
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-center flex-column align-items-center",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _vm.subscriptionChanged
                    ? _c("div", { staticClass: "alert alert-success mb-2" }, [
                        _vm._v(
                          "Subscription package successfully\n                changed\n            "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.errors && !Array.isArray(_vm.errors)
                    ? _c("div", { staticClass: "alert alert-error mb-2" }, [
                        _vm._v(_vm._s(_vm.errors))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.loading
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-form",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.submit()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                Confirm changes\n            "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loading
                    ? _c("pulse-loader", {
                        attrs: { loading: true, color: "#E57722", size: "20px" }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c509428", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c509428","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/settings/UpdateSubScription.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1c509428","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/settings/UpdateSubScription.vue
// module chunks = 0 1